import { EMPTY_OBJECT } from '../../../../constants/common'
import { useMinimizedModalsContext } from '../../../../hooks'

import { resolveMinimizedDraftEntryOpen } from './useDraftCreationModalOpener.utils'

// Convenience hook for surfaces with a static (or hook-level) `sourceId`.
// Surfaces that resolve sourceId per call (per-row openers) should use
// `resolveMinimizedDraftEntryOpen` directly with their own `getEntry` access.
export function useDraftCreationModalOpener({
  minimizeKey,
  sourceId,
  onOpen,
} = EMPTY_OBJECT) {
  const { getEntry } = useMinimizedModalsContext()

  return (payload = EMPTY_OBJECT) => {
    resolveMinimizedDraftEntryOpen({
      action: payload.action,
      entry: getEntry(minimizeKey),
      sourceId,
      onOpen: () => onOpen?.(payload),
    })
  }
}
